module.exports = __webpack_public_path__ + "img/admin_console_add_third_arrow.9ed5b6aa.svg";